import classnames from 'classnames';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { StripVideosListBase } from 'widget/components/videos-list/strip/strip';

import { COMPACT_VIDEOS_IN_ROW, COMPACT_NUMBER_OF_ROWS } from 'shared/constants/compact-layout';

import styles from './content-slider.styl';

//TODO: https://jira.wixpress.com/browse/VOD-176 - get rid of inheritance
@VODCSSModules(styles)
export default class ContentSlider extends StripVideosListBase {
  constructor(props) {
    super(props);

    this.numberOfRows = COMPACT_NUMBER_OF_ROWS;
    this.videosInRow = COMPACT_VIDEOS_IN_ROW;
  }

  static propTypes = {
    prevSlide: React.PropTypes.any,
    nextSlide: React.PropTypes.any,
    currentSlide: React.PropTypes.any,

    // BaseVideosList
    goBack: React.PropTypes.func,
    goForward: React.PropTypes.func,
  };

  get list() {
    const { prevSlide, nextSlide, currentSlide } = this.props;
    const styleNames = classnames('list-wrapper', this.state.currentTransition);

    return (
      <section styleName={styleNames}>
        <div ref={node => (this.currentNode = node)}
             styleName="list current">
          {currentSlide}
        </div>
        <div styleName="list prev">
          {prevSlide}
        </div>
        <div styleName="list next">
          {nextSlide}
        </div>
      </section>
    );
  }

  isContentPresent(slideContent) {
    return _.isArray(slideContent) ? slideContent.length : Boolean(slideContent);
  }

  render() {
    const { className, prevSlide, nextSlide } = this.props;

    return (
      <section className={`qa-widget-video-list ${className}`}
               styleName="container">
        {this.list}
        {this.navButton('prev-button', !this.isContentPresent(prevSlide), this.toPrevPage)}
        {this.navButton('next-button', !this.isContentPresent(nextSlide), this.toNextPage)}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/content-slider/content-slider.js